import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listAllBuildEmployer } from "../../actions/employerAction";
import { listBuildApplyDev } from "../../actions/developerAction";
import DashMenuSm from "../../components/DashMenuSm";
import DevWelcome from "../../components/DevWelcome";
import Message from "../../components/Message";
import DevMenu from "../../components/DevMenu";
import RightDash from "../../components/RightDash";
import { truncateString } from "../../helpers";
import Login from "../Login";
import Signout from "../../components/Signout";
import "../../styles/dashboard.css";

const DeveloperDashboard = ({ history, resizeMenu, setResizeMenu }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const listAllBuild = useSelector((state) => state.listAllBuild);

  const { jobs, loading, error } = listAllBuild;

  const listBuildApply = useSelector((state) => state.listBuildApply);

  const {
    applied,
    loading: appliedloading,
    error: appliederror,
  } = listBuildApply;

  useEffect(() => {
    dispatch(listAllBuildEmployer());
  }, [listAllBuildEmployer]);

  useEffect(() => {
    dispatch(listBuildApplyDev());
  }, [listBuildApplyDev]);

  if (!userInfo) {
    return <Login />;
  }

  if (userInfo && userInfo.role === "employer") {
    history.push("/employer/dashboard");
  }

  return (
    <div className="dashboard">
      <DevMenu resizeMenu={resizeMenu} setResizeMenu={setResizeMenu} />
      <RightDash resizeMenu={resizeMenu} setResizeMenu={setResizeMenu}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="spinner-blue"></div>
          </div>
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <div className="right-wrapper">
            <DevWelcome />
            <div className="main p-3">
              <div className="d-flex wrap">
                <div className="col-md-4 colsm-12 d-flex align-items-center m-25 details px-2 py-1 rounded shadow-sm">
                  <div className="mr-1 details-icon red font-normal">
                    <i class="fas fa-list"></i>
                  </div>
                  <div className="font-normal">
                    <p className="font-weight-bold m-0 text-center">
                      {jobs &&
                        jobs &&
                        jobs.filter((job) => job.status === "progress").length}
                    </p>
                    <p className="font-sm m-0">Available jobs</p>
                  </div>
                </div>
                <div className="col-md-4 colsm-12 d-flex align-items-center m-25 details px-2 py-1 rounded shadow-sm">
                  <div className="mr-1 details-icon blue font-normal">
                    <i class="far fa-bookmark"></i>
                  </div>
                  <div className="font-normal">
                    <p className="font-weight-bold m-0 text-center">
                      {(applied && applied.length) || 0}
                    </p>
                    <p className="font-sm m-0">Jobs applied for</p>
                  </div>
                </div>
              </div>
              {/* <div className="mt-3 dashtable">
                <h4 className="font-medium mb-1">
                  Jobs Applied For ({(applied && applied.length) || 0})
                </h4>
                <div className="overflow-x">
                  <table>
                    <thead>
                      <tr className="text-uppercase tablehead">
                        <th>id</th>
                        <th>date</th>
                        <th>Title</th>
                        <th>Skills </th>
                        <th>Budget(USD)</th>
                        <th colSpan="2">status</th>
                      </tr>
                    </thead>
                    {
                      <tbody>
                        {applied && applied.length === 0 && (
                          <div>No job application yet</div>
                        )}
                        {applied &&
                          applied.slice(0, 5).map((applied) => (
                            <tr key={applied._id}>
                              <td>
                                {applied._id.slice(14, applied._id.length)}
                              </td>
                              <td>{applied.createdAt.slice(0, 10)}</td>
                              <td>{applied.title}</td>
                              <td>{applied.skill}</td>
                              <td>{applied.budget}</td>
                              <td>{applied.status}</td>
                            </tr>
                          ))}
                      </tbody>
                    }
                  </table>
                </div>
              </div> */}
              <div className="my-2 mx-25">
                <h4 className="font-normal mb-25">Jobs Applied For (recent)</h4>
                <div className="overflow-x">
                  <div>
                    {applied && applied.length === 0 && (
                      <div>You've not applied for any job</div>
                    )}
                    {applied &&
                      applied.slice(0, 5).map((applied) => (
                        <div
                          key={applied._id}
                          className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                          <div>
                            <div>
                              <span className="date">
                                {applied.createdAt.slice(0, 10)}
                              </span>
                            </div>
                            <div className="title">
                              <Link
                                to={`/developer/dashboard/job/${applied.build._id}`}>
                                {" "}
                                {applied.build.title}
                              </Link>
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="font-weight-bolder">skill</div>
                            <div className="status">
                              {applied.build && applied.build.skill.join(", ")}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="my-2 mt-3 mx-25">
                <h4 className="font-normal mb-25">Available Jobs (recent)</h4>
                <div className="overflow-x">
                  <div>
                    {jobs && jobs.length === 0 && <div>No job posted yet</div>}
                    {jobs &&
                      jobs.filter((job) => job.status === "progress").length ===
                        0 && <div>Job Applications are being processed</div>}
                    {jobs &&
                      jobs
                        .slice(0, 5)
                        .filter((job) => job.status === "progress")
                        .map((job) => (
                          <div
                            key={job._id}
                            className="d-flex justify-content-between align-items-center table shadow-sm border mb-1 px-1 py-50">
                            <div>
                              <div>
                                <span className="date">
                                  {job.createdAt.slice(0, 10)}
                                </span>
                              </div>
                              <div className="title">
                                <Link
                                  to={`/developer/dashboard/job/${job._id}`}>
                                  {" "}
                                  {job.title}
                                </Link>
                              </div>
                            </div>
                            <div className="text-right">
                              <div className="application font-weight-bolder">
                                Total Application -{" "}
                                <span className="font-weight-bolder">
                                  {job.devapplied.length}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </RightDash>
    </div>
  );
};

export default DeveloperDashboard;
